import React, { useState } from 'react';
import Map from './Map';
import Detail from './Detail';

const App = () => {
  const [current_id, setId] = useState();
  return (
    <div style={{ width: 'calc(100% - 13px)', marginTop: 4, height: 'calc(100% - 4px)' }}>
      <Map setId={id => setId(id)} />
      <Detail current_id={current_id} onClose={() => setId('')} />
    </div>
  );
};

export default App;
